import { ComponentRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { DialogComponent } from '../dialog/dialog.component';

export class DialogRef {
	

	private readonly _afterClosed = new Subject<any>();
	public afterClosed: Observable<any> = this._afterClosed.asObservable();
	public componentRef: ComponentRef<DialogComponent>;

	public close(result?: any): void {
		this._afterClosed.next(result);
	}
}
